export const PLATFORM = {
  FACEBOOK: 'FACEBOOK',
  LINE_LOGIN: 'LINE_LOGIN',
  LINE_MES_API: 'LINE_MES_API',
};

export const TOPIC = {
  MARKETING: 'MARKETING',
  USER_PROFILE: 'USER_PROFILE',
};
